import {createStackNavigator} from '@react-navigation/stack';
import {RootStackParamList} from './RootStackParamList';

const RootStack = createStackNavigator<RootStackParamList>();

export default RootStack;
